import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

/** What a list shows when it has nothing yet (`.emptybig`): an icon, a title, one short line, and the next step. */
export function EmptyState({ icon, title, text, actions }: { icon: IconName; title: ReactNode; text?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="emptybig">
      <span className="eic">
        <Icon name={icon} />
      </span>
      <h2>{title}</h2>
      {text ? <p>{text}</p> : null}
      {actions ? <div className="row g8 mt20 wrap" style={{ justifyContent: "center" }}>{actions}</div> : null}
    </div>
  );
}
